import React, { useState, Component } from 'react';
import { DropletIcon, PlusIcon, LeafIcon, TrendingUpIcon, AwardIcon, MessageSquareIcon, QrCodeIcon, MapPinIcon, BellIcon, UsersIcon, ClockIcon } from 'lucide-react';
import ProgressRing from '../ui/ProgressRing';
import GlassCard from '../ui/GlassCard';
import Button from '../ui/Button';
import { useHydration } from '../../contexts/HydrationContext';
const Dashboard: React.FC = () => {
  const {
    dailyGoal,
    currentIntake,
    addIntake,
    bottlesSaved,
    streakDays,
    userProfile
  } = useHydration();
  const [showAnimation, setShowAnimation] = useState(false);
  const [showQRCode, setShowQRCode] = useState(false);
  const [showCheckIn, setShowCheckIn] = useState(false);
  const [showSharePreview, setShowSharePreview] = useState(false);
  const [shareLocation, setShareLocation] = useState('Smart Soda Fountain');
  const locations = ['Eco Café', 'Fitness Center', 'Hydration Lounge at One Health Clubs', 'Green Hotel', 'Downtown Smart Soda Hub', 'University Campus', 'Central Park Kiosk', 'Organic Market'];
  const progress = currentIntake / dailyGoal;
  const handleAddWater = (amount: number) => {
    setShowAnimation(true);
    addIntake(amount);
    setTimeout(() => setShowAnimation(false), 1500);
  };
  const handleShareViaWhatsApp = () => {
    setShowSharePreview(true);
    setShareLocation('Smart Soda Fountain');
  };
  const handleShareViaSMS = () => {
    setShowSharePreview(true);
    setShareLocation('Smart Soda Fountain');
  };
  const handleSendInvite = () => {
    const message = `Join me at ${shareLocation} for a Smart Soda! Download the app now and get your first drink free!`;
    // In a real app, this would use the Web Share API or open the respective app
    window.open(`https://wa.me/?text=${encodeURIComponent(message)}`, '_blank');
    setShowSharePreview(false);
  };
  return <div className="h-full bg-[#1A237E] pt-12 pb-24 px-4 overflow-y-auto" data-id="element-753">
      <header className="flex justify-between items-center mb-6" data-id="element-754">
        <div data-id="element-755">
          <h1 className="text-2xl font-bold text-[#FAFAFA]" data-id="element-756">
            Hi, {userProfile.name}
          </h1>
          <p className="text-[#00E4BB]" data-id="element-757">Let's stay hydrated!</p>
        </div>
        <div className="flex items-center" data-id="element-758">
          <div className="w-10 h-10 bg-[#00E4BB]/20 rounded-full flex items-center justify-center" data-id="element-759">
            <AwardIcon className="w-5 h-5 text-[#00E4BB]" data-id="element-760" />
          </div>
          <span className="ml-1 text-[#FAFAFA] font-bold" data-id="element-761">{streakDays}</span>
        </div>
      </header>

      {/* Community Check-in Button */}
      <GlassCard className="mb-6 p-2 border-l-4 border-l-[#A6FF4D]" data-id="element-762">
        <div className="flex items-center justify-between" data-id="element-763">
          <div className="flex items-center" data-id="element-764">
            <div className="w-8 h-8 rounded-full bg-[#A6FF4D]/20 flex items-center justify-center mr-2" data-id="element-765">
              <UsersIcon className="w-4 h-4 text-[#A6FF4D]" data-id="element-766" />
            </div>
            <div data-id="element-767">
              <h3 className="text-[#FAFAFA] text-sm font-medium" data-id="element-768">
                Friend Connect
              </h3>
              <p className="text-xs text-gray-300" data-id="element-769">Meet for a drink</p>
            </div>
          </div>
          <Button size="sm" onClick={() => setShowCheckIn(true)} className="bg-[#A6FF4D] text-[#1A237E] border-none text-xs py-1 px-3" data-id="element-770">
            Check In
          </Button>
        </div>
      </GlassCard>

      {/* Check-in Modal */}
      {showCheckIn && <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4" data-id="element-771">
          <div className="bg-[#1A237E] rounded-xl p-5 w-full max-w-xs" data-id="element-772">
            <h3 className="text-xl font-bold text-white mb-4" data-id="element-773">
              Check In & Invite
            </h3>
            <div className="mb-4" data-id="element-774">
              <label className="block text-[#00E4BB] mb-2 text-sm" data-id="element-775">
                Where are you going?
              </label>
              <select className="w-full bg-[#1A237E]/60 border border-[#00E4BB]/30 rounded-lg px-4 py-3 text-white focus:outline-none focus:ring-2 focus:ring-[#00E4BB]" data-id="element-776">
                <option value="" data-id="element-777">Select location</option>
                <option value="eco-cafe" data-id="element-778">Eco Café</option>
                <option value="fitness-center" data-id="element-779">Fitness Center</option>
                <option value="hydration-lounge" data-id="element-780">
                  Hydration Lounge at One Health Clubs
                </option>
                <option value="green-hotel" data-id="element-781">Green Hotel</option>
              </select>
            </div>
            <div className="mb-4" data-id="element-782">
              <label className="block text-[#00E4BB] mb-2 text-sm" data-id="element-783">When?</label>
              <div className="flex space-x-2" data-id="element-784">
                <button className="flex-1 bg-[#00E4BB]/20 text-[#00E4BB] py-2 rounded-lg" onClick={e => {
              // Toggle active state for "Now" button
              const target = e.currentTarget;
              const otherButton = target.nextElementSibling;
              target.classList.add('bg-[#00E4BB]/20', 'text-[#00E4BB]');
              target.classList.remove('bg-[#1A237E]/60', 'border', 'border-[#00E4BB]/30', 'text-white');
              otherButton?.classList.add('bg-[#1A237E]/60', 'border', 'border-[#00E4BB]/30', 'text-white');
              otherButton?.classList.remove('bg-[#00E4BB]/20', 'text-[#00E4BB]');
            }} data-id="element-785">
                  Now
                </button>
                <button className="flex-1 bg-[#1A237E]/60 border border-[#00E4BB]/30 text-white py-2 rounded-lg flex items-center justify-center" onClick={e => {
              // Toggle active state for "Later" button
              const target = e.currentTarget;
              const otherButton = target.previousElementSibling;
              target.classList.add('bg-[#00E4BB]/20', 'text-[#00E4BB]');
              target.classList.remove('bg-[#1A237E]/60', 'border', 'border-[#00E4BB]/30', 'text-white');
              otherButton?.classList.add('bg-[#1A237E]/60', 'border', 'border-[#00E4BB]/30', 'text-white');
              otherButton?.classList.remove('bg-[#00E4BB]/20', 'text-[#00E4BB]');
              // When "Later" is clicked, show time picker or additional options
              const timeOptions = document.getElementById('time-options');
              if (timeOptions) {
                timeOptions.classList.remove('hidden');
              }
            }} data-id="element-786">
                  <ClockIcon className="w-4 h-4 mr-1" data-id="element-787" /> Later
                </button>
              </div>
              {/* Time options that appear when "Later" is selected */}
              <div id="time-options" className="mt-2 hidden" data-id="element-788">
                <select className="w-full bg-[#1A237E]/60 border border-[#00E4BB]/30 rounded-lg px-4 py-2 text-white focus:outline-none focus:ring-2 focus:ring-[#00E4BB]" data-id="element-789">
                  <option value="" data-id="element-790">Select time</option>
                  <option value="30min" data-id="element-791">In 30 minutes</option>
                  <option value="1hour" data-id="element-792">In 1 hour</option>
                  <option value="2hour" data-id="element-793">In 2 hours</option>
                  <option value="custom" data-id="element-794">Custom time</option>
                </select>
              </div>
            </div>
            <div className="mb-4" data-id="element-795">
              <label className="block text-[#00E4BB] mb-2 text-sm" data-id="element-796">
                Invite friends
              </label>
              <div className="flex flex-wrap gap-2 mb-2" data-id="element-797">
                <div className="bg-[#00E4BB]/20 text-[#00E4BB] px-3 py-1 rounded-full text-sm flex items-center" data-id="element-798">
                  Sarah K. <span className="ml-1 cursor-pointer" data-id="element-799">×</span>
                </div>
                <div className="bg-[#00E4BB]/20 text-[#00E4BB] px-3 py-1 rounded-full text-sm flex items-center" data-id="element-800">
                  Mike R. <span className="ml-1 cursor-pointer" data-id="element-801">×</span>
                </div>
                <button className="bg-[#1A237E]/60 border border-[#00E4BB]/30 text-white px-3 py-1 rounded-full text-sm" data-id="element-802">
                  + Add
                </button>
              </div>
            </div>
            <div className="flex items-center mb-6" data-id="element-803">
              <div className="w-5 h-5 bg-[#00E4BB]/20 rounded flex items-center justify-center mr-2" data-id="element-804">
                <BellIcon className="w-3 h-3 text-[#00E4BB]" data-id="element-805" />
              </div>
              <span className="text-sm text-white" data-id="element-806">Enable notifications</span>
              <div className="ml-auto w-10 h-5 bg-[#00E4BB] rounded-full p-0.5 cursor-pointer" onClick={e => {
            const toggle = e.currentTarget.querySelector('div');
            if (toggle) {
              if (toggle.classList.contains('translate-x-5')) {
                toggle.classList.remove('translate-x-5');
                toggle.classList.add('translate-x-0');
                e.currentTarget.classList.remove('bg-[#00E4BB]');
                e.currentTarget.classList.add('bg-gray-300');
              } else {
                toggle.classList.remove('translate-x-0');
                toggle.classList.add('translate-x-5');
                e.currentTarget.classList.remove('bg-gray-300');
                e.currentTarget.classList.add('bg-[#00E4BB]');
              }
            }
          }} data-id="element-807">
                <div className="w-4 h-4 bg-white rounded-full transform translate-x-5 transition-transform duration-200" data-id="element-808"></div>
              </div>
            </div>
            <div className="flex space-x-3" data-id="element-809">
              <Button variant="outline" className="flex-1" onClick={() => setShowCheckIn(false)} data-id="element-810">
                Cancel
              </Button>
              <Button className="flex-1 bg-[#A6FF4D] text-[#1A237E] border-none" onClick={() => setShowCheckIn(false)} data-id="element-811">
                Check In
              </Button>
            </div>
          </div>
        </div>}

      {/* Share Preview Modal */}
      {showSharePreview && <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4" data-id="element-812">
          <div className="bg-white rounded-xl p-5 w-full max-w-xs" data-id="element-813">
            <h3 className="text-lg font-bold text-[#1A237E] mb-4" data-id="element-814">
              Invite Preview
            </h3>
            <div className="bg-gray-100 p-4 rounded-lg mb-4" data-id="element-815">
              <div className="flex items-center mb-3" data-id="element-816">
                <div className="w-10 h-10 rounded-full bg-[#1A237E] flex items-center justify-center mr-3" data-id="element-817">
                  <DropletIcon className="w-5 h-5 text-[#00E4BB]" data-id="element-818" />
                </div>
                <div data-id="element-819">
                  <p className="font-medium text-[#1A237E]" data-id="element-820">
                    Smart Soda Invite
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-821">
                    From: {userProfile.name}
                  </p>
                </div>
              </div>
              <p className="text-[#1A237E] mb-3" data-id="element-822">
                Join me at {shareLocation} for a Smart Soda! Download the app
                now and get your first drink free!
              </p>
              <div className="flex items-center text-xs text-gray-500" data-id="element-823">
                <MapPinIcon className="w-3 h-3 mr-1" data-id="element-824" />
                <select value={shareLocation} onChange={e => setShareLocation(e.target.value)} className="bg-transparent text-xs border-b border-gray-300 focus:outline-none text-[#1A237E]" data-id="element-825">
                  {locations.map((location, index) => <option key={index} value={location} data-id="element-826">
                      {location}
                    </option>)}
                </select>
              </div>
            </div>
            <div className="flex space-x-3" data-id="element-827">
              <Button variant="outline" className="flex-1 border-[#1A237E] text-[#1A237E]" onClick={() => setShowSharePreview(false)} data-id="element-828">
                Cancel
              </Button>
              <Button className="flex-1 bg-[#25D366] border-none text-white" onClick={handleSendInvite} data-id="element-829">
                Send Invite
              </Button>
            </div>
          </div>
        </div>}

      {/* Hydration Progress */}
      <div className="flex flex-col items-center justify-center mb-16 relative" data-id="element-830">
        <ProgressRing progress={progress} size={240} strokeWidth={12} color="#00E4BB" backgroundColor="#607D8B" data-id="element-831">
          <div className="flex flex-col items-center" data-id="element-832">
            <div className="text-4xl font-bold text-[#FAFAFA]" data-id="element-833">
              {Math.round(progress * 100)}%
            </div>
            <div className="text-[#00E4BB] text-sm" data-id="element-834">
              {currentIntake} / {dailyGoal} ml
            </div>
          </div>
        </ProgressRing>
        {/* Smart Soda Tumbler */}
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 translate-y-20" data-id="element-835">
          <div className="relative w-16 h-28" data-id="element-836">
            {/* Tumbler body */}
            <div className="absolute inset-0 bg-[#FAFAFA]/10 backdrop-blur-lg rounded-2xl border border-[#FAFAFA]/20" data-id="element-837">
              {/* Water fill animation */}
              <div className={`absolute bottom-0 left-0 right-0 bg-gradient-to-t from-[#00E4BB] to-[#00E4BB]/70 transition-all duration-1000 ease-out rounded-b-2xl ${showAnimation ? 'animate-pulse' : ''}`} style={{
              height: `${progress * 100}%`
            }} data-id="element-838">
                <div className="absolute top-0 left-0 right-0 h-2 bg-white/20 rounded-full" data-id="element-839"></div>
              </div>
            </div>
            {/* Tumbler lid */}
            <div className="absolute -top-3 left-1/2 transform -translate-x-1/2 w-12 h-3 bg-[#607D8B] rounded-t-xl" data-id="element-840"></div>
            {/* Smart Soda Logo */}
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/scAvhsb3Y8BwMC8wHgqDfw/logo-branding-icon-qcb0z7xkdnwhni6kncu584o6jbzmcxiysh5nu4x4ao.png" alt="Smart Soda Icon" className="absolute bottom-2 left-1/2 transform -translate-x-1/2 w-8 h-8 opacity-50" data-id="element-841" />
          </div>
        </div>
      </div>

      {/* Redeem Drink QR Code Button */}
      <div className="mt-24 mb-6" data-id="element-842">
        <Button fullWidth variant="primary" className="bg-[#00E4BB] text-[#1A237E] border-none py-4" onClick={() => setShowQRCode(true)} data-id="element-843">
          <QrCodeIcon className="w-5 h-5 mr-2" data-id="element-844" />
          Redeem Free Drink
        </Button>
      </div>

      {/* QR Code Modal */}
      {showQRCode && <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4" data-id="element-845">
          <div className="bg-white p-6 rounded-xl w-full max-w-xs" data-id="element-846">
            <div className="w-full h-64 bg-[#1A237E] mb-4 flex items-center justify-center" data-id="element-847">
              <QrCodeIcon className="w-40 h-40 text-white" data-id="element-848" />
            </div>
            <p className="text-[#1A237E] font-medium text-center mb-4" data-id="element-849">
              Show this QR code to redeem your free Smart Soda drink
            </p>
            <Button fullWidth className="bg-[#1A237E] text-white" onClick={() => setShowQRCode(false)} data-id="element-850">
              Close
            </Button>
          </div>
        </div>}

      {/* Quick Add Section */}
      <div data-id="element-851">
        <h2 className="text-xl font-bold text-[#FAFAFA] mb-3" data-id="element-852">Quick Add</h2>
        <div className="grid grid-cols-3 gap-3" data-id="element-853">
          <Button variant="primary" onClick={() => handleAddWater(250)} className="flex flex-col items-center py-3" data-id="element-854">
            <DropletIcon className="w-5 h-5 mb-1" data-id="element-855" />
            <span data-id="element-856">250ml</span>
          </Button>
          <Button variant="primary" onClick={() => handleAddWater(500)} className="flex flex-col items-center py-3" data-id="element-857">
            <DropletIcon className="w-5 h-5 mb-1" data-id="element-858" />
            <span data-id="element-859">500ml</span>
          </Button>
          <Button variant="outline" onClick={() => {}} className="flex flex-col items-center py-3" data-id="element-860">
            <PlusIcon className="w-5 h-5 mb-1" data-id="element-861" />
            <span data-id="element-862">Custom</span>
          </Button>
        </div>
      </div>

      {/* Environmental Impact */}
      <div className="mt-8" data-id="element-863">
        <h2 className="text-xl font-bold text-[#FAFAFA] mb-3" data-id="element-864">Your Impact</h2>
        <GlassCard className="p-4" data-id="element-865">
          <div className="flex items-center" data-id="element-866">
            <div className="w-12 h-12 rounded-full bg-[#C0CA33]/20 flex items-center justify-center mr-4" data-id="element-867">
              <LeafIcon className="w-6 h-6 text-[#C0CA33]" data-id="element-868" />
            </div>
            <div data-id="element-869">
              <h3 className="text-[#FAFAFA] font-bold text-lg" data-id="element-870">
                {bottlesSaved}
              </h3>
              <p className="text-[#607D8B] text-sm" data-id="element-871">Plastic bottles saved</p>
            </div>
          </div>
          <div className="mt-4 h-2 bg-[#1A237E]/50 rounded-full overflow-hidden" data-id="element-872">
            <div className="h-full bg-gradient-to-r from-[#00E4BB] to-[#C0CA33]" style={{
            width: `${Math.min(bottlesSaved / 20 * 100, 100)}%`
          }} data-id="element-873"></div>
          </div>
          <div className="mt-1 text-xs text-right text-[#607D8B]" data-id="element-874">
            Next milestone: 20 bottles
          </div>
        </GlassCard>
      </div>

      {/* Community Check-ins Section */}
      <div className="mt-8" data-id="element-875">
        <h2 className="text-xl font-bold text-[#FAFAFA] mb-3 font-gt-ultra" data-id="element-876">
          Community Check-ins
        </h2>
        <div className="space-y-3" data-id="element-877">
          <GlassCard className="p-4" data-id="element-878">
            <div className="flex items-start" data-id="element-879">
              <div className="w-10 h-10 rounded-full overflow-hidden mr-3 flex-shrink-0" data-id="element-880">
                <img src="https://i.pravatar.cc/100?img=1" alt="Sarah K." className="w-full h-full object-cover" data-id="element-881" />
              </div>
              <div className="w-full" data-id="element-882">
                <p className="text-[#FAFAFA]" data-id="element-883">
                  <span className="font-medium" data-id="element-884">Sarah K.</span> is at{' '}
                  <span className="text-[#00E4BB]" data-id="element-885">
                    Hydration Lounge at One Health Clubs
                  </span>
                </p>
                <div className="flex items-center mt-1 text-sm text-[#607D8B]" data-id="element-886">
                  <ClockIcon className="w-3 h-3 mr-1" data-id="element-887" /> Now • 2 friends joined
                </div>
                <div className="flex mt-2 space-x-2" data-id="element-888">
                  <Button size="sm" className="bg-[#A6FF4D] text-[#1A237E] border-none" data-id="element-889">
                    Join
                  </Button>
                </div>
              </div>
            </div>
          </GlassCard>
          <GlassCard className="p-4" data-id="element-890">
            <div className="flex items-start" data-id="element-891">
              <div className="w-10 h-10 rounded-full overflow-hidden mr-3 flex-shrink-0" data-id="element-892">
                <img src="https://i.pravatar.cc/100?img=2" alt="Mike R." className="w-full h-full object-cover" data-id="element-893" />
              </div>
              <div className="w-full" data-id="element-894">
                <p className="text-[#FAFAFA]" data-id="element-895">
                  <span className="font-medium" data-id="element-896">Mike R.</span> is heading to{' '}
                  <span className="text-[#00E4BB]" data-id="element-897">Eco Café</span>
                </p>
                <div className="flex items-center mt-1 text-sm text-[#607D8B]" data-id="element-898">
                  <ClockIcon className="w-3 h-3 mr-1" data-id="element-899" /> In 20 minutes • 1
                  friend joined
                </div>
                <div className="flex mt-2 space-x-2" data-id="element-900">
                  <Button size="sm" className="bg-[#A6FF4D] text-[#1A237E] border-none" data-id="element-901">
                    Join
                  </Button>
                </div>
              </div>
            </div>
          </GlassCard>
        </div>
      </div>

      {/* Friend Requests */}
      <div className="mt-8" data-id="element-902">
        <h2 className="text-xl font-bold text-[#FAFAFA] mb-3 font-gt-ultra" data-id="element-903">
          Friend Requests
        </h2>
        <div className="space-y-3" data-id="element-904">
          <GlassCard className="p-4 border-l-4 border-l-[#A6FF4D]" data-id="element-905">
            <div className="flex items-start" data-id="element-906">
              <div className="w-10 h-10 rounded-full overflow-hidden mr-3 flex-shrink-0" data-id="element-907">
                <img src="https://i.pravatar.cc/100?img=3" alt="Alex M." className="w-full h-full object-cover" data-id="element-908" />
              </div>
              <div className="flex-1" data-id="element-909">
                <p className="text-[#FAFAFA]" data-id="element-910">
                  <span className="font-medium" data-id="element-911">Alex M.</span> added you as a
                  friend
                </p>
                <div className="flex items-center mt-1 text-sm text-[#607D8B]" data-id="element-912">
                  <ClockIcon className="w-3 h-3 mr-1" data-id="element-913" /> 2 hours ago
                </div>
                <div className="flex space-x-2 mt-3" data-id="element-914">
                  <Button size="sm" className="bg-[#A6FF4D] text-[#1A237E] border-none" data-id="element-915">
                    Accept
                  </Button>
                  <Button size="sm" variant="outline" className="border-[#00E4BB]/30 text-[#00E4BB]" data-id="element-916">
                    Decline
                  </Button>
                </div>
              </div>
            </div>
          </GlassCard>
          <GlassCard className="p-4 border-l-4 border-l-[#A6FF4D]" data-id="element-917">
            <div className="flex items-start" data-id="element-918">
              <div className="w-10 h-10 rounded-full overflow-hidden mr-3 flex-shrink-0" data-id="element-919">
                <img src="https://i.pravatar.cc/100?img=4" alt="Jamie T." className="w-full h-full object-cover" data-id="element-920" />
              </div>
              <div className="flex-1" data-id="element-921">
                <p className="text-[#FAFAFA]" data-id="element-922">
                  <span className="font-medium" data-id="element-923">Jamie T.</span> added you as a
                  friend
                </p>
                <div className="flex items-center mt-1 text-sm text-[#607D8B]" data-id="element-924">
                  <ClockIcon className="w-3 h-3 mr-1" data-id="element-925" /> 5 hours ago
                </div>
                <div className="flex space-x-2 mt-3" data-id="element-926">
                  <Button size="sm" className="bg-[#A6FF4D] text-[#1A237E] border-none" data-id="element-927">
                    Accept
                  </Button>
                  <Button size="sm" variant="outline" className="border-[#00E4BB]/30 text-[#00E4BB]" data-id="element-928">
                    Decline
                  </Button>
                </div>
              </div>
            </div>
          </GlassCard>
        </div>
      </div>

      {/* Reminder Card */}
      <div className="mt-6" data-id="element-929">
        <GlassCard className="p-4 border-l-4 border-l-[#FF9800]" data-id="element-930">
          <div className="flex items-center" data-id="element-931">
            <div className="w-10 h-10 rounded-full bg-[#FF9800]/20 flex items-center justify-center mr-3" data-id="element-932">
              <TrendingUpIcon className="w-5 h-5 text-[#FF9800]" data-id="element-933" />
            </div>
            <div data-id="element-934">
              <h3 className="text-[#FAFAFA] font-medium" data-id="element-935">Time for a sip!</h3>
              <p className="text-sm text-[#607D8B]" data-id="element-936">
                You're 25% behind your usual pace. Today's high temperature
                (82°F) means you should drink more!
              </p>
            </div>
          </div>
        </GlassCard>
      </div>

      {/* Social Feed */}
      <SocialFeed data-id="element-937" />

      {/* Nearby Offers */}
      <NearbyOffers data-id="element-938" />
    </div>;
};
const SocialFeed: React.FC = () => {
  const friendActivities = [{
    id: 1,
    name: 'Sarah K.',
    action: 'redeemed Berry Blast',
    location: 'Eco Café',
    time: '5m ago',
    avatar: 'https://i.pravatar.cc/100?img=1'
  }, {
    id: 2,
    name: 'Mike R.',
    action: 'earned Hydration Hero badge',
    location: 'Fitness Center',
    time: '15m ago',
    avatar: 'https://i.pravatar.cc/100?img=2'
  }];
  return <div className="mt-8" data-id="element-939">
      <h2 className="text-xl font-bold text-[#FAFAFA] mb-3 font-gt-ultra" data-id="element-940">
        Friend Activity
      </h2>
      <div className="space-y-3" data-id="element-941">
        {friendActivities.map(activity => <GlassCard key={activity.id} className="p-4" data-id="element-942">
            <div className="flex items-center" data-id="element-943">
              <img src={activity.avatar} alt={activity.name} className="w-10 h-10 rounded-full mr-3" data-id="element-944" />
              <div className="flex-1" data-id="element-945">
                <p className="text-[#FAFAFA]" data-id="element-946">
                  <span className="font-medium" data-id="element-947">{activity.name}</span>{' '}
                  {activity.action}
                </p>
                <p className="text-sm text-[#607D8B]" data-id="element-948">
                  {activity.location} • {activity.time}
                </p>
              </div>
              <button className="w-8 h-8 bg-[#FAFAFA]/10 rounded-full flex items-center justify-center" data-id="element-949">
                <MessageSquareIcon className="w-4 h-4 text-[#00E4BB]" data-id="element-950" />
              </button>
            </div>
          </GlassCard>)}
      </div>
    </div>;
};
const NearbyOffers: React.FC = () => {
  const offers = [{
    id: 1,
    title: 'New Flavor: Tropical Breeze',
    location: 'All locations',
    description: 'Try our latest summer sensation!',
    image: 'https://example.com/tropical.jpg'
  }, {
    id: 2,
    title: 'Happy Hour Special',
    location: 'Eco Café',
    description: 'Double points 2-4PM daily',
    image: 'https://example.com/happy-hour.jpg'
  }];
  return <div className="mt-8" data-id="element-951">
      <h2 className="text-xl font-bold text-[#FAFAFA] mb-3 font-gt-ultra" data-id="element-952">
        Nearby Offers
      </h2>
      <div className="space-y-3" data-id="element-953">
        {offers.map(offer => <GlassCard key={offer.id} className="p-4" data-id="element-954">
            <div className="flex items-center" data-id="element-955">
              <div className="w-12 h-12 bg-[#00E4BB]/20 rounded-lg flex items-center justify-center mr-4" data-id="element-956">
                <DropletIcon className="w-6 h-6 text-[#00E4BB]" data-id="element-957" />
              </div>
              <div className="flex-1" data-id="element-958">
                <h3 className="text-[#FAFAFA] font-medium" data-id="element-959">{offer.title}</h3>
                <p className="text-sm text-[#607D8B]" data-id="element-960">{offer.location}</p>
                <p className="text-sm text-[#00E4BB] mt-1" data-id="element-961">
                  {offer.description}
                </p>
              </div>
            </div>
          </GlassCard>)}
      </div>
    </div>;
};
export default Dashboard;